import React from 'react';
import './OurTechnology.css';

const OurTechnology = () => {
    return (
        <section className="our-technology">
            <div className="our-technology-container">
                <div className="technology-header">
                    <span className="section-label">Our Technologies</span>
                    <h2 className="technology-title">Artificial General Intelligence</h2>
                    <p className="technology-subtitle">
                        Partsol's approach to AGI consists of a proprietary suite of methodologies,
                        algorithms, and enabling technologies that function together as a unified,
                        general-purpose cognitive engine.
                    </p>
                    <p className="technology-subtitle-secondary">
                        This engine is built to operate across an unlimited range of knowledge areas
                        and problem spaces (domains), delivering insights, predictions, and reasoning
                        that mirror - and in some cases exceed - human cognitive performance.
                    </p>
                </div>

                <div className="technology-grid">
                    {/* Atai Box with Video */}
                    <div className="technology-card atai-card">
                        <div className="card-content">
                            <div className="card-icon">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M12 6v6l4 2" />
                                </svg>
                            </div>
                            <h3 className="card-title">Atai</h3>
                            <p className="card-description">
                                Partsol's flagship Cognitive AI SaaS platform, built on proprietary AI Stem Cells
                                and Absolute Truth Algorithms. Unlike traditional AI, Atai eliminates
                                hallucinations and delivers actionable insights that are precise, reliable,
                                and tailored to your industry's needs. The industry's most comprehensive,
                                automated platform for identity forensics (e.g., KYC, jury selection,
                                pre-employment screening, and candidate due diligence) and entity forensics
                                (e.g., CDD, FBO, and M&A target identification, among many others).
                            </p>
                            <div className="card-features">
                                <span className="feature">✓ No Hallucinations</span>
                                <span className="feature">✓ Precision Intelligence</span>
                                <span className="feature">✓ Industry-Adaptive</span>
                            </div>
                            <div className="card-video-wrapper">
                                <iframe
                                    className="card-video-iframe"
                                    src="https://www.youtube.com/embed/uvZg0rJEYNs"
                                    title="Atai Platform Video"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>

                    {/* AI Stem Cells Box */}
                    <div className="technology-card stem-cells-card">
                        <div className="card-content">
                            <div className="card-icon">
                                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <circle cx="12" cy="12" r="3" />
                                    <circle cx="12" cy="5" r="2" />
                                    <circle cx="19" cy="12" r="2" />
                                    <circle cx="12" cy="19" r="2" />
                                    <circle cx="5" cy="12" r="2" />
                                    <line x1="12" y1="7" x2="12" y2="9" />
                                    <line x1="17" y1="12" x2="15" y2="12" />
                                    <line x1="12" y1="15" x2="12" y2="17" />
                                    <line x1="9" y1="12" x2="7" y2="12" />
                                </svg>
                            </div>
                            <h3 className="card-title">AI Stem Cells</h3>
                            <p className="card-description">
                                A groundbreaking framework inspired by biological stem cells. They allow
                                Atai to adapt and evolve to meet the unique demands of any industry while
                                maintaining the integrity of Absolute Truth. This adaptability makes Atai
                                scalable, reliable, and versatile.
                            </p>
                            <div className="card-features">
                                <span className="feature">✓ Domain Adaptable</span>
                                <span className="feature">✓ Scalable Architecture</span>
                                <span className="feature">✓ Absolute Truth</span>
                            </div>
                            <div className="card-video-wrapper">
                                <iframe
                                    className="card-video-iframe"
                                    src="https://www.youtube.com/embed/a-kD-2mGr5Q"
                                    title="AI Stem Cells Video"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurTechnology;
